module.exports = __webpack_public_path__ + "img/icon-4.ef6d70e6.png";